import "./Aboutus.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import React, { useEffect, useState, useCallback } from "react";
import Basic from "../components/Basic";
import Footer from "../components/Footer";
import "./Home1.css";
//import { Link } from "react-router-dom";
import Dialog from "../components/Dialog";
import axios from "axios";
import UserModal from "../components/UserModal";
//import Imageslide from "./Imageslide";
import { Pagination } from "react-bootstrap";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router-dom";
//import SearchIcon from "@mui/icons-material/Search";
//import { FaSearch } from "react-icons/fa";

function Home1() {
  const [currentPage, setCurrentPage] = useState(1);
  const [plantsPerPage] = useState(24);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [Plants, setPlants] = useState([]);
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");

  const fetchPlants = useCallback(() => {
    axios
      .get(
        `https://server-zqk9.onrender.com/Home?search=${searchTerm}`
      )
      .then((response) => {
        setPlants(response.data);
      })
      .catch((err) => console.log(err));
  }, [searchTerm]);

  // Debounce function
  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const debouncedFetchPlants = useCallback(
    debounce(fetchPlants, 500), // Adjust the delay time as needed
    [fetchPlants]
  );

  useEffect(() => {
    // Fetch plants initially
    debouncedFetchPlants();

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = -1;

      if (scrollPosition > scrollThreshold) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [debouncedFetchPlants, location]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    // Trigger the debounced fetchPlants function when the search input changes
    debouncedFetchPlants();
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastPlant = currentPage * plantsPerPage;
  const indexOfFirstPlant = indexOfLastPlant - plantsPerPage;
  const currentPlants = Plants.slice(indexOfFirstPlant, indexOfLastPlant);

  return (
    <>
      <Basic />

      <div className="containersec1">
        <div className="header1">
          <h1>
            <span>WELCOME </span>TO{" "}
            <span style={{ color: "#179f3e" }}>HERBAL CARTEL</span>
          </h1>

          <p>
            Explore nature's remedies with a curated collection of plants known
            for their healing properties. Discover herbal wisdom,benefits and
            usage to embrace your well-being naturally. <br />
          </p>
          <div className="header2">
            <p>“वसुंधरा उत्पत्ति स्थिति लय हेतु||”</p>
          </div>
          <div className="Homecon">
            <div className="row">
              <div className="col-md-7 ">
                <p>
                  <span
                    style={{
                      fontWeight: "900",
                      color: "black",
                    }}
                  >
                    Nature is the reason behind creation, preservation and
                    destruction.
                  </span>{" "}
                  <br /> With a long and rich history, the interaction between
                  humans and environment is intricate and nuanced. It may be
                  seen from many angles, each emphasizing a distinct facet of
                  this complex relationship. Plants are woven throughout every
                  aspect of human existence, from the food on our plates to the
                  oxygen we breathe. They are the green, quiet engines that run
                  our world, transforming sunlight into the energy that keeps us
                  all alive. Plants are the base of the food chain, they provide
                  us with direct nutrition in the form of fruits, vegetables,
                  and grains, and they also provide indirect nutrition for the
                  animals we eat.
                  <br />
                  However, their contributions go well beyond the dinner table.
                  By collecting carbon dioxide, a dangerous chemical that
                  human's breath, and releasing oxygen, which is necessary for
                  life, plants serve as nature's air cleansers. There are strong
                  spiritual ties between many civilizations and people and the
                  natural world. In addition to providing comfort and a sense of
                  community, people view nature as a source of inspiration,
                  beauty, and rejuvenation. This link has the power to inspire
                  people to conserve the environment and take care of it. They
                  control the climate, lowering heat waves and halting soil
                  erosion. While medicinal plants have been the foundation of
                  healing for millennia, forests offer natural sanctuaries that
                  promote comfort and leisure. Every blade of grass, no matter
                  how big or little, is essential to our ecology, from the
                  stately redwoods to the common houseplant.
                </p>
              </div>
              <div className="col-md-4 ">
                <img src="Home.png" alt="img" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="Home">
        <div className="Sections">
          <div className="col-md-6 main">
            <h1>
              <u>Plant List</u>
            </h1>
          </div>
          <div className="plant">
            <p>
              Below, you'll find a catalog of plants accompanied by insightful
              information
            </p>
          </div>
          <br />

          <div className="col-md-6 d-flex justify-content-end">
            <div className="search-bar-container">
              <input
                type="text"
                className="form-control search-bar-input"
                placeholder="Search for plants"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button
                type="button"
                className="searchbtn"
                onClick={handleSearch}
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  color: "white",
                  cursor: "pointer",
                  marginRight: "50px",
                }}
              >
                {/* <SearchIcon /> */}
              </button>
            </div>
          </div>

          <div className="container-fluid">
            <div className="row">
              {currentPlants.length > 0 ? (
                currentPlants.map((plant, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="container1 py-2">
                      <div className="rectangle1">
                        <div className="circle">
                          <img src={`${plant?.image?.images}`} alt="" />
                        </div>
                        <div className="content1">
                          <Dialog {...plant} />
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-md-12">
                  <center>
                    <h2 style={{ color: "white", fontSize: "20px" }}>
                      Sorry, the plant you're looking for isn't found in our
                      records.
                    </h2>
                  </center>
                </div>
              )}
            </div>
            <div className="pagination-container d-flex justify-content-center mt-3 display-2">
              <Pagination>
                <Pagination.Prev
                  disabled={currentPage === 1}
                  onClick={() => paginate(currentPage - 1)}
                >
                  <FaAngleLeft />
                </Pagination.Prev>

                {Array.from({
                  length: Math.ceil(Plants.length / plantsPerPage),
                }).map((_, index) => {
                  if (
                    (currentPage <= 2 && index < 3) ||
                    (currentPage > 2 &&
                      index >= currentPage - 2 &&
                      index <= currentPage)
                  ) {
                    return (
                      <Pagination.Item
                        key={index}
                        active={index + 1 === currentPage}
                        onClick={() => paginate(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    );
                  }
                  return null;
                })}

                <Pagination.Next
                  disabled={
                    currentPage === Math.ceil(Plants.length / plantsPerPage)
                  }
                  onClick={() => paginate(currentPage + 1)}
                >
                  <FaAngleRight />
                </Pagination.Next>
              </Pagination>
            </div>
          </div>

          <Tooltip title="Add plants">
            <button className="Addbtn ">
              <UserModal />
            </button>
          </Tooltip>
          {showScrollButton && (
            <Tooltip title="Scroll up">
              <button className="back-to-top" onClick={scrollToTop}>
                <FaAngleUp />
              </button>
            </Tooltip>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Home1;
